
import React from 'react';
import { FormattedReview } from "@/types";
import { ReviewStars } from './ReviewStars';

interface ReviewCardProps {
  review: FormattedReview;
}

export const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const truncateText = (text: string, maxLength: number = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 shadow-sm">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2 sm:gap-3">
          {review.profilePhoto && (
            <img
              src={review.profilePhoto}
              alt={review.author}
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover"
            />
          )}
          <div>
            <h4 className="font-medium text-gray-900 text-xs sm:text-sm">{review.author}</h4>
            <ReviewStars rating={review.rating} />
          </div>
        </div>
        <span className="text-xs text-gray-500">{review.relativeTime}</span>
      </div>
      
      {review.text && (
        <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
          {truncateText(review.text, 80)}
        </p>
      )}
    </div>
  );
};
